<!--  -->
<template>
  <div class="page">
    <div class="bg"></div>
    <div class="section">
      <div class="back" @click="back" v-if="!($root.$data.isApp || this.$root.miniprogram)"></div>
      <div class="title">
        <div class="icon"></div>
        <div class="name">
          <span>{{ showStatus() }}</span
          ><img
            v-if="invoiceDetail.invoiceStatus === 1"
            @click="show = true"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/icon1.png"
            alt=""
          />
        </div>
      </div>
      <div class="price">
        <span>开票金额</span>
        <b>￥{{ invoiceDetail.goodsTotalPriceTax }}</b>
      </div>
      <div class="content">
        <div class="preview" @click="toPreview" v-if="invoiceDetail.pdfUrlList">
          <div class="img">
            <div>共{{ invoiceDetail.pdfUrlList.length }}张</div>
          </div>
          <div class="btn">点击预览发票</div>
        </div>
        <div class="form-item">
          <div class="form-label">发票类型</div>
          <span class="form-value">电子普通发票</span>
        </div>
        <div class="form-item">
          <div class="form-label">发票内容</div>
          <span class="form-value">商品类别</span>
        </div>
        <div class="form-item">
          <div class="form-label">抬头类型</div>
          <span class="form-value">{{ invoiceDetail.naturalMark == '1' ? '个人' : '单位' }}</span>
        </div>
        <template v-if="invoiceDetail.naturalMark == 0">
          <div class="form-item">
            <div class="form-label">抬头名称</div>
            <span class="form-value">{{ invoiceDetail.buyerName }}</span>
          </div>
          <div class="form-item">
            <div class="form-label">单位税号</div>
            <span class="form-value">{{ invoiceDetail.buyerTaxNo }}</span>
          </div>
          <div class="form-item" v-if="invoiceDetail.buyerAddress">
            <div class="form-label">注册地址</div>
            <span class="form-value">{{ invoiceDetail.buyerAddress }}</span>
          </div>
          <div class="form-item" v-if="invoiceDetail.buyerTelephone">
            <div class="form-label">注册电话</div>
            <span class="form-value">{{ invoiceDetail.buyerTelephone }}</span>
          </div>
          <div class="form-item" v-if="invoiceDetail.buyerBankName">
            <div class="form-label">开户银行</div>
            <span class="form-value">{{ invoiceDetail.buyerBankName }}</span>
          </div>
          <div class="form-item" v-if="invoiceDetail.buyerBankNumber">
            <div class="form-label">银行账号</div>
            <span class="form-value">{{ invoiceDetail.buyerBankNumber }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="dialog" v-if="show">
      <div class="content">
        <div class="title">说明</div>
        <div class="msg">发票将在24小时内开具，请稍后查看</div>
        <div class="btn" @click="show = false">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqInvoiceDetail } from '@/api/personal/index';

export default {
  components: {},
  data() {
    return {
      invoiceDetail: {},
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    back() {
      this.$router.go(-1);
    },
    async getInvoiceDetail() {
      const { data } = await reqInvoiceDetail(this.$route.query.orderNo);
      this.invoiceDetail = data || {};
      this.showStatus();
    },
    showStatus() {
      const { invoiceStatus } = this.invoiceDetail;
      return invoiceStatus === 1
        ? '正在开票'
        : invoiceStatus === 2
        ? '已开票'
        : invoiceStatus === 4
        ? '开票失败'
        : '';
    },
    toPreview() {
      window.sessionStorage.setItem('pdfLinks', JSON.stringify(this.invoiceDetail.pdfUrlList));
      this.$router.push({ path: '/invoicePreview' });
    },
  },
  created() {},
  mounted() {
    this.getInvoiceDetail();
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  .bg {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 542px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/bg.png');
    background-size: 100%;
  }
  .section {
    position: relative;
    z-index: 2;
    padding: 78px 36px 0 36px;

    .back {
      width: 43px;
      height: 43px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/back.png');
      background-size: 100%;
    }
    .title {
      .icon {
        width: 91px;
        height: 91px;
        margin: 0 auto 14px;
        background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/icon.png');
        background-size: 100%;
      }
      .name {
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          padding-right: 7px;
          color: #fff;
          font-weight: 500;
          font-size: 33px;
        }
        img {
          width: 29px;
          height: 29px;
        }
      }
    }
    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 678px;
      height: 87px;
      margin: 36px 0 22px 0;
      padding: 24px 29px;
      background: #fff;
      border-radius: 14px;
      span {
        color: #333;
        font-weight: 400;
        font-size: 29px;
      }
      b {
        color: #ff3938;
        font-weight: 500;
        font-size: 29px;
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: 822px;
      padding: 24px 29px;
      background: #fff;
      border-radius: 14px;
      .preview {
        position: absolute;
        top: 25px;
        right: 29px;
        width: 208px;
        .img {
          position: relative;
          width: 208px;
          height: 136px;
          background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/preview.png');
          background-size: 100%;
          div {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 208px;
            height: 36px;
            color: #fff;
            font-weight: 400;
            font-size: 22px;
            line-height: 36px;
            text-align: center;
            background: #000;
            border-radius: 0 0 11px 11px;
            opacity: 0.6;
          }
        }
        .btn {
          padding-top: 18px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          text-align: center;
        }
      }
      .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 49px;
        .form-label {
          flex-shrink: 0;
          width: 180px;
          // margin-right: 10px;
          // margin-right: 58px;
          color: #333;
          font-weight: 400;
          font-size: 29px;
          text-align: left;
        }
        .form-value {
          color: #333;
          font-weight: 400;
          font-size: 25px;
        }
      }
    }
  }
  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 634px;
      background: #fff;
      border-radius: 36px;
      transform: translate(-50%, -50%);
      .title {
        padding: 31px 0 43px 0;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        text-align: center;
      }
      .msg {
        padding-bottom: 87px;
        color: #333;
        font-weight: 400;
        font-size: 29px;
        text-align: center;
      }
      .btn {
        color: #ff7f41;
        font-weight: 500;
        font-size: 29px;
        line-height: 91px;
        text-align: center;
        border-top: 1px solid #efefef;
      }
    }
  }
}
</style>
